// Single source of truth for per-rail-type Thai labels. Used by the Home rail (railTypeMap)
// and the QueueMenuV2026 title so both always agree.
export const RAIL_LABELS = {
  customer: 'คุณลูกค้า',
  beneat_professional: 'คุณแม่บ้าน',
  professional: 'ผู้สมัคร',
  professional_secondary: 'ผู้สมัคร (สำรอง)',
  sales_product_customer: 'คุณลูกค้า (Sales)',
  recruitment_customer: 'คุณลูกค้า (Recruit)',
  recruitment_professional: 'คุณแม่บ้าน (Recruit)',
  recruitment_professional_secondary: 'คุณแม่บ้าน (Recruit สำรอง)',
  mari_customer: 'คุณลูกค้า (Mari)',
  mari_professional: 'ผู้สมัคร (Mari)'
}

// เปิดทุก rail ตอนพัฒนา โดยไม่ต้องแก้สิทธิ์ใน DB. ตัวนี้ตัวเดียวคุมทั้งแถบ rail และปุ่มที่ผูกกับ
// สิทธิ์ rail — ห้ามแยกไปเขียน devMode ซ้ำในคอมโพเนนต์ ไม่งั้นสองที่จะหลุดจากกัน
export const RAIL_DEV_MODE = false

/**
 * rail ที่แอดมินคนนี้ "เห็น" — แหล่งความจริงเดียวของแถบ rail (Home.vue) และของทุกปุ่มที่เงื่อนไข
 * คือ "เห็น rail นี้ไหม". อ่านจาก payload ตอน login (chat-server indexController)
 */
export function visibleRailTypes (admin) {
  if (RAIL_DEV_MODE) {
    return Object.keys(RAIL_LABELS)
  }
  const types = admin && admin.customer_types && admin.customer_types.types
  return Array.isArray(types) ? types : []
}

/** แอดมินคนนี้เห็น rail นี้ไหม */
export function canSeeRail (admin, railType) {
  return visibleRailTypes(admin).indexOf(railType) !== -1
}

// ลำดับ rail ที่แอดมินจัดเอง — เก็บใน localStorage ของเบราว์เซอร์นี้ แยกตามแอดมิน (เครื่องเดียวอาจใช้หลายคน)
// แสดงผลอย่างเดียว: ไม่แตะ customer_types (สิทธิ์ + types[0] = หน้าเริ่มต้นตอนกดโลโก้ ยังเหมือนเดิม)
const RAIL_ORDER_KEY_PREFIX = 'v2026-rail-order:'

function railOrderKey (admin) {
  return admin && admin.id ? RAIL_ORDER_KEY_PREFIX + admin.id : null
}

export function loadRailOrder (admin) {
  const key = railOrderKey(admin)
  if (!key) return null
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key))
    return Array.isArray(parsed) ? parsed : null
  } catch (e) {
    return null
  }
}

export function saveRailOrder (admin, order) {
  const key = railOrderKey(admin)
  if (!key) return
  try {
    window.localStorage.setItem(key, JSON.stringify(order))
  } catch (e) {
    // โหมดส่วนตัว / storage เต็ม — ลำดับอยู่ได้แค่รอบนี้
  }
}

export function clearRailOrder (admin) {
  const key = railOrderKey(admin)
  if (!key) return
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    // ไม่มีอะไรให้ล้าง
  }
}

/**
 * เรียง types ตามลำดับที่บันทึกไว้ — rail ที่ไม่มีในลำดับ (เพิ่งได้สิทธิ์ใหม่) ต่อท้ายตามลำดับเดิม
 * rail ที่เสียสิทธิ์ไปแล้วถูกตัดทิ้งเอง เพราะตั้งต้นจาก types ไม่ใช่จาก order
 */
export function applyRailOrder (types, order) {
  if (!Array.isArray(order) || order.length === 0) return types.slice()
  const rank = (type) => {
    const i = order.indexOf(type)
    return i === -1 ? order.length + types.indexOf(type) : i
  }
  return types.slice().sort((a, b) => rank(a) - rank(b))
}
